import { EFinancingCompany } from '@if/core/types'
import { LoanDashboardEntry } from '@src/components/LoanList/loan-filters-schema'
import { apiClient } from '@src/services/http-common'
import { useQuery, type UseQueryResult } from '@tanstack/react-query'

const fifteenMinutes = 900000
const SCOPE = 'loanDashboardEntries'

export const loanDashboardQueryKeys = {
  all: [SCOPE] as const,
}

export interface LoanDashboardEntriesParams {
  financingCompanyId: EFinancingCompany
  searchTerm: string
  offset: number
  limit: number
}

const buildSearchParams = ({ searchTerm, offset, limit }: LoanDashboardEntriesParams) => {
  const params = new URLSearchParams({
    offset: String(offset),
    limit: String(limit),
  })
  if (searchTerm) params.set('searchTerm', searchTerm)
  return params
}

const getLoanDashboardEntries = async (params: LoanDashboardEntriesParams): Promise<LoanDashboardEntry[]> => {
  const company = encodeURIComponent(params.financingCompanyId)
  const url = `${company}/loans/dashboard-entries?${buildSearchParams(params).toString()}`
  const response = await apiClient.get<LoanDashboardEntry[]>(url)
  return response.data
}

export function useGetLoanDashboardEntries(params: LoanDashboardEntriesParams): UseQueryResult<LoanDashboardEntry[]> {
  return useQuery({
    queryKey: [...loanDashboardQueryKeys.all, params],
    queryFn: () => getLoanDashboardEntries(params),
    staleTime: fifteenMinutes,
    gcTime: fifteenMinutes,
  })
}
